import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { apiEnpoints } from 'src/app/core/helpers/api-endpoints';
import { ApiService } from 'src/app/core/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { error } from 'console';

@Component({
  selector: 'app-order-pdf-view',
  templateUrl: './order-pdf-view.component.html',
  styleUrl: './order-pdf-view.component.scss'
})
export class OrderPdfViewComponent {
  loading = true;
  subscription:Subscription[] = [];
  error = false;

  constructor(
    private ApiService :ApiService,
    private route:ActivatedRoute,

  ){

  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      console.log('Order ID:', id);

      if (id) {
        this.getReleventData(id);
      }
    });
  }

  getReleventData(id){

    if (!id) {
      console.error('No ID found in route parameters');
      return;
    }

    this.subscription.push(
      this.ApiService.apiAuthGet(`${apiEnpoints.getQuatationData}?poMasterId=${id}`)
        .subscribe({
          next: (res) => {
            if (res['code'] === 1) {
              sessionStorage.setItem('quotationData', JSON.stringify(res));

              setTimeout(() => {
                this.loading = false;

                // Wait a bit for DOM to render before printing
                setTimeout(() => {
                  window.print();
                }, 500);
              }, 1000);
            }
          },
          error: (err) => {
            console.error('API error:', err);
            this.error = true;
          }
        })
    );

  }

  reloadPage() {
    window.location.reload();
  }

}
